import { View } from "@-/com.npmjs.react-native";
import type { ReactNode } from "react";

// Lays the slide's blocks out with consistent spacing. MDX passes the compiled content as ONE
// element whose fragment renders the blocks, so the inter-block "\n" strings never reach this
// component; the Metro transformer's `rehype-strip-block-whitespace` plugin removes them.
export function SlideMdxWrapper({ children }: { children?: ReactNode }) {
  return <View className="flex-col gap-4">{children}</View>;
}
